// date functions
Date.prototype.toUTC = function() {
	return new Date(this.getTime() + this.getTimezoneOffset() * 60 * 1000);
};

Date.prototype.fromUTC = function() {
	return new Date(this.getTime() - this.getTimezoneOffset() * 60 * 1000);
};

Date.prototype.trimTime = function() {
	this.setHours(0, 0, 0, 0);
	return this;
};

var _DatetoJSON = Date.prototype.toJSON;
Date.prototype.toJSON = function() {
  try {
    return _DatetoJSON.call(this);
  } catch(e) {
    if (e instanceof RangeError) {
      return null;
    }
    throw e;
  }
};

Date.DifferenceInMinutes = function(firstDate, secondDate) {
    var diffInMins = null;
    if(firstDate && secondDate){
        var _MS_TO_MINUTES =  1000 * 60;
        var date1 = new Date(firstDate);
        var date2 = new Date(secondDate);
        diffInMins =  Math.floor((date2.getTime() - date1.getTime()) / _MS_TO_MINUTES);
    }
    return  diffInMins;
};

Date.DifferenceInDays = function (firstDate, secondDate) {
    var diffInDays = null;
    if (firstDate && secondDate){
        var _MS_TO_DAYS = 1000 * 3600 * 24;
        diffInDays = Math.floor((secondDate.getTime() - firstDate.getTime()) / _MS_TO_DAYS);
    }
    return diffInDays;
}


Date.MinutesToString = function(minutes){
    var hours = Math.floor( minutes / 60);          
    var mins = minutes % 60;
    return (hours > 0 ? hours + (hours == 1 ? "hr ": "hrs ") : "") + (mins > 0 ? mins + (mins == 1 ? "min": "mins") : "");
}


Date.prototype.AddDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}
          
Date.MinutesToStringSimple = function(minutes){
  var hours =  Math.floor(minutes / 60);          
  var mins = minutes % 60;
  return (hours != 0 ? (hours + ":") : ("00" + ":" )) + (mins > 9 ? mins : "0" + mins);
}
